// Mirrors the backend ProjectEntityType / ProjectBudgetType (openwrench-app
// app/models/workorder/Project.scala). A project declares which entities it has
// via `entities`; the Deliverables / Tasks tabs are gated on this.
export const PROJECT_ENTITY_TYPES = {
	workOrders: 'work_orders',
	tasks: 'tasks',
	deliverables: 'deliverables',
};

export const PROJECT_ENTITY_TYPE_OPTIONS = [
	{ label: 'Work Orders', value: PROJECT_ENTITY_TYPES.workOrders },
	{ label: 'Tasks', value: PROJECT_ENTITY_TYPES.tasks },
	{ label: 'Deliverables', value: PROJECT_ENTITY_TYPES.deliverables },
];

export const PROJECT_BUDGET_TYPES = {
	total: 'total',
	individual: 'individual',
};
